// 全ページ共通の追従「PAGE TOP」ボタン
// - 1画面分スクロールしたら .is-visible を付けて出現させ、押下でページ最上部へ戻る
// - 画面下部を占有する要素（Flipdeskのチャットバナー / 検索・物件詳細の下部CTAバー）と
//   重ならないよう、避けた位置を --page-top-bottom に入れて縦積みにする
const STACK_GAP = 12; // 縦積み時の要素間の余白(px)

// Flipdesk(外部チャットツール)のバナーは Shadow DOM の中に描画されるため、
// document.querySelector では拾えず、ホスト要素の shadowRoot を辿る必要がある。
// SPでは横幅320pxのバナーが画面右下まで広がりボタンと重なるが、
// PCでは下部中央（右端まで届かない）に出るため、横位置が重なったときだけ避ける。
const FLIPDESK_HOST_ID = "flipdesk_shadow_host";
const FLIPDESK_TRIGGER_SELECTOR = "#flipdesk-trigger";
// バナーの枠外(上)にはみ出す閉じるボタン。バナー本体と併せて避ける対象にする
const FLIPDESK_CLOSE_SELECTOR = ".flipdesk-trigger_expire";
// GTM経由の非同期読み込みなので、ホストが現れるまで探し続ける(500ms × 60 = 30秒)
const FLIPDESK_POLL_INTERVAL = 500;
const FLIPDESK_POLL_LIMIT = 60;

const main = () => {
    const button = document.querySelector("[data-page-top]");
    if (!button) return;

    // 物件詳細では fixed、検索・一覧では sticky と、ページによって固定方法が変わる下部CTAバー
    const bottomBar = document.querySelector(".c-others-search-submit");

    const isRendered = (el) => el && el.isConnected && window.getComputedStyle(el).display !== "none";

    const flipdeskShadowRoot = () => {
        const host = document.getElementById(FLIPDESK_HOST_ID);
        return host ? host.shadowRoot : null;
    };

    // Flipdeskバナーのうち、いま表示されている要素（本体＋閉じるボタン）
    const flipdeskObstacles = () => {
        const root = flipdeskShadowRoot();
        if (!root) return [];

        const trigger = root.querySelector(FLIPDESK_TRIGGER_SELECTOR);
        if (!isRendered(trigger)) return [];

        return [trigger, root.querySelector(FLIPDESK_CLOSE_SELECTOR)].filter(isRendered);
    };

    // ボタンは画面右端に固定されているため、横位置が重なる障害物だけ避ければよい
    const overlapsHorizontally = (rect) => {
        const buttonRect = button.getBoundingClientRect();
        return rect.right > buttonRect.left && rect.left < buttonRect.right;
    };

    // 画面下端から測った「障害物の上端」の高さ(px)。障害物がなければ0
    const obstacleTopFromBottom = () => {
        const viewportHeight = window.innerHeight;
        let top = 0;

        // Flipdeskバナーは画面下部に固定表示される。横位置が重なるとき（＝SP表示のとき）だけ、
        // 閉じるボタンのはみ出しも含めた上端まで避ける
        flipdeskObstacles().forEach((el) => {
            const rect = el.getBoundingClientRect();
            if (!overlapsHorizontally(rect)) return;
            top = Math.max(top, viewportHeight - rect.top);
        });

        // 下部CTAバーは画面下端に張り付いているときだけ避ける
        // （sticky が解除されて本来の位置に流れた状態は障害物にならない）
        if (isRendered(bottomBar)) {
            const rect = bottomBar.getBoundingClientRect();
            if (rect.bottom >= viewportHeight - 1 && rect.top < viewportHeight) {
                top = Math.max(top, viewportHeight - rect.top);
            }
        }

        return top;
    };

    const updatePosition = () => {
        const top = obstacleTopFromBottom();
        if (top > 0) {
            button.style.setProperty("--page-top-bottom", `${Math.round(top + STACK_GAP)}px`);
        } else {
            button.style.removeProperty("--page-top-bottom");
        }
    };

    const updateVisibility = () => {
        button.classList.toggle("is-visible", window.scrollY > window.innerHeight);
    };

    let ticking = false;
    const update = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
            updateVisibility();
            updatePosition();
            ticking = false;
        });
    };

    button.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    });

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    // 下部CTAバーの高さが変わったときにも位置を追従させる
    if (window.ResizeObserver && bottomBar) {
        const observer = new window.ResizeObserver(updatePosition);
        observer.observe(bottomBar);
    }

    // Flipdeskはバナーを読み込み完了後に Shadow DOM の中へ差し込み、
    // 閉じられると取り除く。ホストが現れ次第、中身の出し入れを監視する
    const observeFlipdesk = () => {
        const root = flipdeskShadowRoot();
        if (!root) return false;

        if (window.MutationObserver) {
            const observer = new window.MutationObserver(update);
            observer.observe(root, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ["class", "style"],
            });
        }
        updatePosition();
        return true;
    };

    if (!observeFlipdesk()) {
        let waited = 0;
        const timer = window.setInterval(() => {
            waited += 1;
            if (observeFlipdesk() || waited >= FLIPDESK_POLL_LIMIT) {
                window.clearInterval(timer);
            }
        }, FLIPDESK_POLL_INTERVAL);
    }

    updateVisibility();
    updatePosition();
};

export default main;
